<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <div>
    <b-form-textarea maxlength="1500" v-model="message"></b-form-textarea>

    <section class="full-width d-flex justify-content-end mt-1">
      <b-btn :class="{'disabled': message.length < 1 || loading}" @click="sendReply()" variant="success">Send Reply</b-btn>
    </section>
  </div>
</template>
<!-- eslint-enable -->

<script>
import DigitalRepliesService from '@/services/DigitalRepliesService'

export default {
  components: {},
  props: {
    post: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      message: '',
      loading: false,
    }
  },
  mounted() {

  },
  methods: {
    sendReply() {
      this.loading = true;

      // eslint-disable-next-line no-underscore-dangle
      DigitalRepliesService.sendReply(this.message, this.post._id).then(() => {
        this.$toast.success('Successfully sent reply', {
          toastClassName: ['toast-std', 'success-toast'],
        });

        this.message = ''; // reset message
      }).catch(err => {
        let msg = 'Could not reply to post, please refresh and try again';
        const errorFound = err && err.response && err.response.data;

        if (errorFound && err.response.data.error === 'ENTITY_ALREADY_EXISTS') {
          msg = 'There is already a reply awaiting approval, you can only have one reply per post';
        }
        this.$toast.error(msg, {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
      })
    },
  },
}
</script>
